import { Component, Input } from '@angular/core';
import { QuestionFactComponent } from '../question-fact/question-fact.component';
import { MatDialog } from '@angular/material/dialog';
import { AmplitudeService } from 'src/app/services/external-tools/amplitude.service';


@Component({
  selector: 'app-reporting-card',
  templateUrl: './reporting-card.component.html',
  styleUrls: ['./reporting-card.component.scss'],
  standalone: false
})
export class ReportingCardComponent {
  @Input() title: string = '';
  @Input() callName: string = '';
  @Input() numberOfCalls: number | null = null;
  @Input() questionName: string = '';
  @Input() percentage: string = '';
  @Input() totalScore: number = 5;
  @Input() barType: 'highest' | 'lowest' = 'highest';
  @Input() modalTitle: string = '';
  @Input() barMode: string = '';
  @Input() barMsg: string = '';
  @Input() payload: any | undefined;
  @Input() accountUuid: string = '';
  @Input() moduleUuid: string = '';
  @Input() moduleName: string = '';
  @Input() callTypesInModule: string = '';
  @Input() isMsgAdherence: boolean = false;
  @Input() modalType: string = '';

  constructor(
    private dialog: MatDialog,
    private amplitudeService: AmplitudeService
  ) {}


  calculateProgress(progressString: string, total: number): any {

    let progress = Number(progressString);
    if (progress < 0) progress = 0;
    if (progress > total) progress = total;
    let filled = Math.floor(progress);
    return { filled: filled, partial: progress - filled };
  }

  openModal() {
    // Sending the Event of Clicking on Highlight View Info to Amplitude
    this.amplitudeService.trackEvent('modulereport_click_highlightviewinfo', {
      'card_title': this.title,
    });

    let height = '680px';
    if (this.modalType === 'Most Missed Answer Point Question' || this.modalType === 'Least Missed Answer Point Question'
    ) {
      height = '366px';
    } else if (this.modalType === 'Highest Scoring Objective' || this.modalType === 'Lowest Scoring Objective'
    ) {
      height = 'auto';
    } else if (this.modalType === 'Most Articulated Message' || this.modalType === 'Least Articulated Message'
    ) {
      height = 'auto';
      this.payload.name = this.questionName;
    }
    this.dialog.open(QuestionFactComponent, {
      hasBackdrop: true,
      width: '917px',
      height: height,
      panelClass: 'cards-modal',
      data: {
        accountUuid: this.accountUuid,
        callUuid: this.payload.callUuid,
        questionUuid: this.payload.questionUuid,
        isModal: true,
        type: this.modalType,
        callName: this.callName,
        callType: this.payload.callType,
        name: this.payload.name,
        factNumber: this.payload.factNumber,
        call: this.payload,
        moduleName: this.moduleName,
        moduleUuid: this.moduleUuid,
        translatedType: this.modalTitle
      }
    });
  }
}